const Fish = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={''}
      role="presentation"
      pointerEvents="none"
    >
      <title>Fish</title>
      <path
        fill="#2b2b2b"
        d="M27.19,15.84a1.46,1.46,0,0,0-.38-.95,16.75,16.75,0,0,0-5-3.77,8.88,8.88,0,0,0-3.68-.87,9.44,9.44,0,0,0-4.54,1.28A18,18,0,0,0,9,15.34a2.07,2.07,0,0,0-.31.48,2.11,2.11,0,0,0-.25,1,2.17,2.17,0,0,0,.24,1,2.34,2.34,0,0,0,.3.47,19.65,19.65,0,0,0,3.68,3.34l.16-.18a2.8,2.8,0,0,1,.91-.61,17.47,17.47,0,0,1-3.79-3.36,1,1,0,0,1,0-1.36c1.54-1.75,4.66-4.67,8.21-4.67,3.32,0,6.29,2.65,7.77,4.24a.19.19,0,0,1,.05.13.24.24,0,0,1-.05.14c-.21.25-.49.57-.84.92l-.4.4.8,1a.22.22,0,0,1,.05.14.2.2,0,0,1-.06.14A13.17,13.17,0,0,1,20,22.06a4.48,4.48,0,0,1-.62,1.42,13.37,13.37,0,0,0,6.94-4,1.44,1.44,0,0,0,.08-2l-.06-.08.5-.57A1.47,1.47,0,0,0,27.19,15.84Z"
      />
      <path
        fill="transparent"
        stroke="#2b2b2b"
        d="M5.31,13.5h0V11.11h0a.31.31,0,0,1,.07-.21.34.34,0,0,1,.18-.12.38.38,0,0,1,.21,0,.36.36,0,0,1,.16.14h0l3,5.33a1.23,1.23,0,0,1,.15.56,1.13,1.13,0,0,1-.15.57h0l-3,5.43h0a.32.32,0,0,1-.16.14.31.31,0,0,1-.21,0,.32.32,0,0,1-.18-.12.31.31,0,0,1-.07-.2h0v-2.5h0A3,3,0,0,1,5.6,18.9a2.84,2.84,0,0,1,.83-1,1.39,1.39,0,0,0,.4-.47A1.43,1.43,0,0,0,7,16.83a1.39,1.39,0,0,0-.14-.6,1.31,1.31,0,0,0-.4-.47,3,3,0,0,1-.83-1A2.87,2.87,0,0,1,5.31,13.5Z"
      />
      <path
        fill="transparent"
        stroke="#2b2b2b"
        d="M21.81,11.22l-3.57-.71h-.1a7.43,7.43,0,0,0-3.15.75l-.4.19a4.76,4.76,0,0,1-.49.22.61.61,0,0,1-.21.06A3.68,3.68,0,0,1,12,8.5h0V6.83a.33.33,0,0,1,.1-.23.35.35,0,0,1,.24-.1h5a4.51,4.51,0,0,1,4.5,4.5Z"
      />
      <path fill="#2b2b2b" d="M22.31,16.83a.83.83,0,1,0,0-1.66.83.83,0,1,0,0,1.66Z" />
      <path
        fill="transparent"
        stroke="#2b2b2b"
        d="M14.64,20.85h5a.35.35,0,0,1,.24.1.34.34,0,0,1,.1.23,4.49,4.49,0,0,1-4.5,4.5H12.14a.33.33,0,0,1-.23-.09.37.37,0,0,1-.1-.24V23.68a2.83,2.83,0,0,1,2.83-2.83Z"
      />
    </svg>
  );
};

export default Fish;
